import { render, staticRenderFns } from "./user_dpfw_add.vue?vue&type=template&id=02b95286&scoped=true"
import script from "./user_dpfw_add.vue?vue&type=script&lang=js"
export * from "./user_dpfw_add.vue?vue&type=script&lang=js"
import style0 from "./user_dpfw_add.vue?vue&type=style&index=0&id=02b95286&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b95286",
  null
  
)

export default component.exports